import { z } from "zod";

export const zAttrArticleView = z.object({
  view: z.literal("ArticleView"),
});
export type ZAttrArticleView = z.infer<typeof zAttrArticleView>;
